import "./scss/style.scss";
import "virtual:svg-icons-register";

import "animate.css";

import initPhoneMask from "./js/util/phoneMask";
import initIntroSwiper from "./js/components/introSwiper";
import initComandsSwiper from "./js/components/comandsSwiper";
import { initBurger } from "./js/components/burger";
import { initSelect } from "./js/util/slimSelect";
import initModals from "./js/components/initModal";
import validate from "./js/module/validate";

import { getCatalog } from "./js/module/getCatalog";
import { getAuto } from "./js/module/getAuto";
import { filter } from "./js/module/filter";
import videoInit from "./js/module/video-info";
import reviewsInit from "./js/module/reviews";
import showFilter from "./js/module/showFilter";

window.ajax_url = `/ajax.php`;
window.api_url = "https://cx09748.tw1.ru/ajax.php";
window.domain_url = `${window.location.origin}${window.ajax_url}`;

const btn = document.querySelector(".reviews__btn");
const list = document.querySelector(".dropdown-list");

if (btn && list) {
  // Открытие/закрытие при клике на кнопку
  btn.addEventListener("click", (e) => {
    e.stopPropagation();
    e.preventDefault();
    list.classList.toggle("show");
  });

  // Закрытие при клике вне
  document.addEventListener("click", (e) => {
    // Проверяем, что клик не по кнопке и не по списку и не по его дочерним элементам
    if (!btn.contains(e.target) && !list.contains(e.target)) {
      list.classList.remove("show");
    }
  });

  // Закрытие при клике на ESC
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      list.classList.remove("show");
    }
  });

  // Закрытие при клике на ссылки внутри списка (опционально)
  const links = list.querySelectorAll("a");
  links.forEach((link) => {
    link.addEventListener("click", () => {
      list.classList.remove("show");
    });
  });
}

// Бургер меню
initBurger();
// Маска для телефона в модалке
const inputTelModal = document.getElementById("modal-phone");
if (inputTelModal) {
  initPhoneMask(inputTelModal);
}
// Кнопка скролла
document.addEventListener("DOMContentLoaded", () => {
  const scrollButton = document.getElementById("scrollToTopButton");

  // Показ кнопки при скролле
  window.addEventListener("scroll", () => {
    if (window.scrollY > 200) {
      scrollButton.classList.add("show");
    } else {
      scrollButton.classList.remove("show");
    }
  });

  // Скролл наверх при клике
  scrollButton.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
});
// Форма в модалке
const modalAgreeEl = document.getElementById("modal-agree");
if (modalAgreeEl) {
  modalAgreeEl.addEventListener("change", (e) => {
    const modalSubmitEl = document.getElementById("modal-submit");
    if (!modalSubmitEl) return;

    if (e.target.checked) {
      modalSubmitEl.disabled = false;
    } else {
      modalSubmitEl.disabled = true;
    }
  });
}
const modalSubmitEl = document.getElementById("modal-submit");
if (modalSubmitEl) {
  modalSubmitEl.addEventListener("click", (e) => {
    const formEl = e.target.closest("form");
    if (formEl) {
      validate(formEl);
    }
  });
}

const pageEl = document.querySelector(".page");
if (pageEl) {
  switch (pageEl.getAttribute("id")) {
    case "index":
      videoInit();
      // Флаг, чтобы карта грузилась только один раз
      let mapLoaded = false;

      const mapWrapper = document.getElementById("maps");

      // Создаём наблюдатель
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !mapLoaded) {
              mapLoaded = true;

              // Подгружаем скрипт Яндекс.Карт динамически
              const script = document.createElement("script");
              script.src =
                "https://api-maps.yandex.ru/2.1/?apikey=2e77f9d6-5d6b-474b-a897-c6c0d0e43f0f&lang=ru_RU";
              script.async = true;
              script.defer = true;

              script.onload = () => {
                ymaps.ready(initMap);
              };

              document.body.appendChild(script);

              // Отключаем наблюдатель, карта уже загружена
              observer.unobserve(mapWrapper);
            }
          });
        },
        {
          root: null,
          threshold: 0.1,
        },
      );

      observer.observe(mapWrapper);

      // getCatalog();

      // Функция инициализации карты
      function initMap() {
        const isMobile = window.innerWidth < 768;

        const map = new ymaps.Map("map", {
          // center: [43.116854, 131.893287],
          center: [43.120998, 131.890801],
          zoom: isMobile ? 20 : 18,
          controls: [],
        });

        const placemark = new ymaps.Placemark(
          // [43.116885, 131.891423],
          [43.120978, 131.889401],
          {
            balloonContent: "г. Владивосток, Пологая улица, 65а",
            iconContent: "VDK авто",
          },
          {
            preset: "islands#redStretchyIcon",
          },
        );

        map.geoObjects.add(placemark);
      }

      // Маска для номера телефона
      const inputTel = document.getElementById("phone");
      if (inputTel) {
        initPhoneMask(inputTel);
      }
      // Ждём загрузки API
      // Слайдер в блоке Этапы работы
      // initIntroSwiper();
      initComandsSwiper();
      // initReviewsSwiper();

      const agreeEl = document.getElementById("agree");
      if (agreeEl) {
        agreeEl.addEventListener("change", (e) => {
          const submitEl = document.getElementById("form-submit");
          if (!submitEl) return;

          if (e.target.checked) {
            submitEl.disabled = false;
          } else {
            submitEl.disabled = true;
          }
        });
      }
      const submitEl = document.getElementById("form-submit");
      if (submitEl) {
        submitEl.addEventListener("click", (e) => {
          const formEl = e.target.closest("form");
          if (formEl) {
            if (
              formEl.hasAttribute("id") &&
              formEl.getAttribute("id") === "index-form"
            ) {
              formEl.classList.add("active");
            }
            validate(formEl);
          }
        });
      }

      document.addEventListener("DOMContentLoaded", () => {
        const links = document.querySelectorAll(
          ".navbar-menu__link[data-name]",
        );
        const items = [];

        links.forEach((link) => {
          const name = link.dataset.name;

          // Ищем секцию сначала по id, потом по class
          const section =
            document.getElementById(name) ||
            document.querySelector(`section.${name}`);

          if (section) {
            items.push({ link, section });
          }
        });

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              const current = items.find((i) => i.section === entry.target);
              if (!current) return;

              items.forEach((i) =>
                i.link.classList.remove("navbar-menu__link--active"),
              );

              current.link.classList.add("navbar-menu__link--active");
            });
          },
          {
            root: null,
            rootMargin: "-45% 0px -45% 0px", // 🎯 центр экрана
            threshold: 0,
          },
        );

        items.forEach((item) => observer.observe(item.section));
      });

      setTimeout(() => {
        const section = document.getElementById("catalogue-going");
        const btn = document.getElementById("btn-catalogue");

        const observer2 = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                btn.classList.add("animate__animated", "animate__fadeInUp");

                // если нужно один раз — отключаем наблюдение
                observer2.unobserve(section);
              }
            });
          },
          {
            threshold: 0.05,
          },
        );

        observer2.observe(section);

        // const section2 = document.getElementById("services");
        const section2 = document.getElementById("warranty");
        const btn2 = document.getElementById("btn-catalogue-going");

        const observer3 = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                btn2.classList.add("animate__animated", "animate__fadeInUp");

                // если нужно один раз — отключаем наблюдение
                observer3.unobserve(section2);
              }
            });
          },
          {
            // threshold: 0.05,
            threshold: 0.01, // ✅ Очень маленький порог
            rootMargin: "0px 0px -10px 0px", // ✅ Срабатывает чуть раньше
          },
        );

        observer3.observe(section2);
        // }, 300);
      }, 50);

      reviewsInit();
      break;
    case "catalogue":
    case "catalogue-going":
      // тут года
      years();
      // тут для цены
      price();

      const selectEls = document.querySelectorAll(".custom-select__field");
      if (selectEls.length !== 0) {
        selectEls.forEach((element) => {
          initSelect(`#${element.getAttribute("id")}`);
        });
      }

      initIntroSwiper();
      // Кнопка ПОКАЗАТЬ ПРЕДЛОЖЕНИЯ
      // filter();
      // получение списка авто
      // getCatalog();

      const filterSubmitEl = document.getElementById("filter-submit");
      if (filterSubmitEl) {
        filterSubmitEl.addEventListener("click", (e) => {
          // getCatalog();
          showFilter();
        });
      }

      const loadMoreEl = document.getElementById("more__see");
      if (loadMoreEl) {
        loadMoreEl.addEventListener("click", (e) => {
          const inputPageEl = document.querySelector('[name="page"]');
          let numberPage = Number(inputPageEl.value);
          let newPage = numberPage + 1;
          inputPageEl.value = String(newPage);
          // getCatalog(String(newPage));
        });
      }

      break;
    case "card":
      getAuto("get_auto_card");
      break;
    case "cardmy":
      getAuto("get_auto_cardmy");
      break;
    default:
      break;
  }
}

// Модалка
initModals();

function price() {
  const priceInputs = document.querySelectorAll(
    "#price_from, #price_to, #mileage_from, #mileage_to",
  );

  priceInputs.forEach((input) => {
    input.addEventListener("input", () => {
      // Удаляем все нецифровые символы
      let numericValue = input.value.replace(/\D/g, "");

      // Форматируем с пробелами для тысяч
      input.value = numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    });
  });
}

function years() {
  const startSelect = document.getElementById("year_from");
  const endSelect = document.getElementById("year_to");

  if (!startSelect || !endSelect) return;

  const startYear = 2000;
  const currentYear = new Date().getFullYear();

  // очищаем (на случай повторного вызова)
  // startSelect.innerHTML = `<option value="${startYear}" selected>От</option>`;
  startSelect.innerHTML = `<option value="" selected>От</option>`;
  // endSelect.innerHTML = `<option value="${currentYear}" selected>До</option>`;
  endSelect.innerHTML = `<option value="" selected>До</option>`;

  // Заполняем селекты
  for (let year = currentYear; year >= startYear; year--) {
    // year-start
    const optionStart = document.createElement("option");
    optionStart.value = year;
    optionStart.textContent = `от ${year}`;
    startSelect.append(optionStart);

    // year-end
    const optionEnd = document.createElement("option");
    optionEnd.value = year;
    optionEnd.textContent = `до ${year}`;
    endSelect.append(optionEnd);
  }

  // Обновление year-end при выборе year-start
  startSelect.addEventListener("change", () => {
    const startValue =
      startSelect.value === "all" ? startYear : Number(startSelect.value);

    Array.from(endSelect.options).forEach((option) => {
      if (option.value === "all") return;

      option.disabled = Number(option.value) < startValue;
    });

    // если выбран end меньше start — сбрасываем
    if (endSelect.value !== "all" && Number(endSelect.value) < startValue) {
      endSelect.value = "all";
    }
  });
}
